import { useMemo } from "react";
import type { ThreadListItem } from "@/entities/thread";
import { useNgStore } from "@/features/ng-filter/stores/ngStore";

/**
 * カタロググリッド向けの NG フィルター適用フック。
 *
 * 検索クエリは /search エンドポイント (post 単位の全文検索) で扱うようになったため
 * (Issue #284)、ここではタイトル検索を行わず NG フィルターのみ適用する。
 */
export function useFilteredThreads(
  threads: ThreadListItem[] | undefined,
): ThreadListItem[] {
  const { isThreadHidden, showNgContent } = useNgStore();

  return useMemo(() => {
    if (!threads) return [];
    return threads.filter((thread) => {
      if (!showNgContent && isThreadHidden(thread)) return false;
      return true;
    });
  }, [threads, isThreadHidden, showNgContent]);
}
